import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    EntityCacheDispatcher,
    EntityCollectionServiceElementsFactory,
    HttpUrlGenerator,
    Logger,
    QueryParams
} from '@ngrx/data';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { WebsocketBrokerService } from '../core/services/websocket-broker.service';
import { WebSocketEntityCollectionServiceBase } from '../state/entity/web-socket-entity-collection-service-base';
import { Message } from './message.model';
import { MessageEntityDataServiceBase } from './state/message-entity-data-service.base';
import { patientMessageEntityMetadata, PatientMessageQueryFilter } from './state/message.entity';

/**
 * This is the direct interface to the entity - getting selectors and calling methods to dispatch actions.
 */
@Injectable()
export class PersonMessageService extends WebSocketEntityCollectionServiceBase<Message> {
    queryFilter$: Observable<PatientMessageQueryFilter>;
    refreshing$: Observable<boolean>;

    constructor(
        serviceElementsFactory: EntityCollectionServiceElementsFactory,
        public http: HttpClient) {
        super(patientMessageEntityMetadata.entityName, serviceElementsFactory);

        this.queryFilter$ = this.selectors$['queryFilter$'];
        this.refreshing$ = this.selectors$['refreshing$'];
    }

    getMessageContentByMessageUuid(messageUuid: string, mediaType: string, messageType: string): Observable<any> {
        return this.http
            .post(`/servlets/gateway/log/messagedata/uuid/${messageUuid}/`, {mediaType, messageType})
            .pipe(
                map((response: any) => response.messageData)
            );
    }

    getMessageContentByTrackingCode(trackingCode: string, mediaType: string, messageType: string): Observable<any> {
        return this.http
            .post(`/servlets/gateway/log/messagedata/trackingcode/${trackingCode}/`, {mediaType, messageType})
            .pipe(
                map((response: any) => response.messageData)
            );
    }
}

/**
 * This is the data service NgRx Data will use to call from effects to make the actual calls to the backend.
 */
@Injectable()
export class PersonMessageEntityDataService extends MessageEntityDataServiceBase<Message> {
    constructor(http: HttpClient,
                httpUrlGenerator: HttpUrlGenerator,
                logger: Logger,
                public entityCacheDispatcher: EntityCacheDispatcher,
                public websocketBrokerService: WebsocketBrokerService) {
        super(http, httpUrlGenerator, logger, entityCacheDispatcher, websocketBrokerService, 'PersonMessage', 'person-messages/');
        logger.log('Created custom PersonMessage EntityDataService');
    }

    getMessages(parameters: string | QueryParams): Observable<Array<Message>> {
        const personId = parameters['personId'];

        return this.http.get(`/servlets/messages/persons/${personId}/`)
            .pipe(
                map((response: any) => {
                    const messages = response.messages;
                    messages.queryFilter = response.queryFilter;

                    return messages as any;
                })
            );
    }

    subscribeWebSocketJob(parameters: string | QueryParams): void {
        this.subscribeWebSocketJobWithBody({
            personId: +parameters['personId'],
            offset: 0
        });
    }

    refreshWebSocketJob(parameters: string | QueryParams): void {
        this.refreshWebSocketJobWithBody({
            personId: +parameters['personId'],
            offset: +parameters['offset']
        });
    }
}
